import React from "react";

export default function Selector({ boards, classes, subjects, selected, onSelect, loading }) {
  return (
    <div style={s.wrapper}>
      <Group label="Board">
        {boards.map((b) => (
          <Chip key={b.id} active={selected.board === b.id} onClick={() => onSelect("board", b.id)}>{b.name}</Chip>
        ))}
      </Group>

      {classes.length > 0 && (
        <Group label="Class">
          {classes.map((c) => (
            <Chip key={c.id} active={selected.class === c.id} onClick={() => onSelect("class", c.id)}>
              {c.number}
            </Chip>
          ))}
        </Group>
      )}

      {subjects.length > 0 && (
        <Group label="Subject">
          {subjects.map((sub) => (
            <Chip key={sub.id} active={selected.subject === sub.id} onClick={() => onSelect("subject", sub.id)}>
              <span style={{ fontSize: 14 }}>{sub.icon}</span> {sub.name}
            </Chip>
          ))}
        </Group>
      )}

      {loading && <div style={s.loading}>Loading…</div>}
    </div>
  );
}

function Group({ label, children }) {
  return (
    <div style={s.group}>
      <div style={s.label}>{label}</div>
      <div style={s.chips}>{children}</div>
    </div>
  );
}

function Chip({ active, onClick, children }) {
  return (
    <button
      style={{ ...s.chip, ...(active ? s.chipActive : {}) }}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

const s = {
  wrapper: { background: "#1e293b", borderRadius: 16, padding: "18px 20px", marginBottom: 28 },
  group: { marginBottom: 14 },
  label: { fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", color: "#475569", marginBottom: 8, fontFamily: "'Sora',sans-serif" },
  chips: { display: "flex", flexWrap: "wrap", gap: 7 },
  chip: {
    padding: "7px 14px", borderRadius: 100,
    border: "1.5px solid #334155", background: "transparent",
    color: "#94a3b8", fontSize: 13, fontWeight: 500,
    cursor: "pointer", fontFamily: "'Sora',sans-serif",
    display: "flex", alignItems: "center", gap: 5,
    minHeight: 36,
  },
  chipActive: { background: "#3b82f6", borderColor: "#3b82f6", color: "#fff" },
  loading: { fontSize: 12, color: "#475569", fontFamily: "'Sora',sans-serif" },
};
